var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-select-options__item",class:{ 'is-selected': _vm.isSelected },on:{"click":_vm.change}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.option.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }